// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#hotel .classification[data-v-0c4fc3ce],#hotel .hotel-title[data-v-0c4fc3ce]{font-size:28px;line-height:28px}#hotel .hotel-title[data-v-0c4fc3ce]{font-weight:700;margin-top:15px}#hotel .classification[data-v-0c4fc3ce]{justify-content:center;margin-bottom:25px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
